module.exports = __webpack_public_path__ + "img/logo-2.231c6739.webp";